import { createFileRoute } from '@tanstack/react-router'
import { ScheduledMaintenanceListPage } from 'pages/app/service-schedule/ScheduledMaintenanceListPage'
import { z } from 'zod'

const scheduledMaintenanceSearchSchema = z.object({
  page: z.number().int().positive().optional().catch(1),
  sortBy: z.enum(['nextMaintenanceDateInYYYYMM15']).optional().catch(undefined),
  sortDirection: z.enum(['ASC', 'DESC']).optional().catch(undefined),
  itemId: z.number().int().positive().optional().catch(undefined),
  query: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/app/service-schedule')({
  component: ScheduledMaintenanceListPage,
  validateSearch: scheduledMaintenanceSearchSchema,
})
